<div class="container-fluid py-3">
  <div class="card shadow rounded-4 border-0">
    <div
      class="card-body py-3 px-4 d-flex justify-content-between align-items-center"
    >
      <div class="d-flex align-items-center gap-2">
        <span class="text-dark text-xs fw-bold">{{ title }}</span>
      </div>
      <div class="d-flex align-items-center gap-2">
        <slot></slot>
        <button
          @click="show_quality_modal"
          class="btn btn-bg-green text-xs rounded-small shadow-sm"
        >
          <i class="bi bi-download"></i>
          Download PDF
        </button>
      </div>
    </div>
  </div>
</div>

<!-- PDF Quality Modal -->
<Teleport to="body">
  <div
    class="modal fade"
    :id="modal_id"
    tabindex="-1"
    :aria-labelledby="modal_id + '-label'"
    aria-hidden="true"
  >
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded-4 shadow">
      <div class="modal-header">
        <h5 class="modal-title" :id="modal_id + '-label'">
          Select PDF Quality
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="radio"
            :name="'pdfQuality-' + id"
            :id="'qualityLow-' + id"
            value="low"
            v-model="selected_quality"
          />
          <label class="form-check-label" :for="'qualityLow-' + id">
            Low Quality (Smaller file size, faster generation)
          </label>
        </div>
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="radio"
            :name="'pdfQuality-' + id"
            :id="'qualityMedium-' + id"
            value="medium"
            v-model="selected_quality"
          />
          <label class="form-check-label" :for="'qualityMedium-' + id">
            Medium Quality (Balanced option)
          </label>
        </div>
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="radio"
            :name="'pdfQuality-' + id"
            :id="'qualityHigh-' + id"
            value="high"
            v-model="selected_quality"
          />
          <label class="form-check-label" :for="'qualityHigh-' + id">
            High Quality (Larger file size, slower generation)
          </label>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-bg-secondary" data-bs-dismiss="modal">
          Cancel
        </button>
        <button type="button" class="btn btn-bg-green" @click="download_pdf">
          Download
        </button>
      </div>
    </div>
  </div>
</div>
</Teleport>